//Google AI assistant
export function getCookie(name) {
  const nameEQ = name + "=";
  // Decode the entire cookie string to handle special characters
  const decodedCookie = decodeURIComponent(document.cookie);
  // Split the cookie string into an array of individual cookies
  const ca = decodedCookie.split(";");

  // Loop through the array to find the matching cookie
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    // Remove leading whitespace from the cookie string
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    // If the cookie string starts with the desired name, extract and return its value
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  // Return an empty string if the cookie is not found
  return "";
}
